/**
 * **The one place the dashboard spells a vertical.**
 *
 * Seven screens ask the same question — does this org file its records under
 * protection accounts — and until the security fold each asked it by comparing
 * `org.vertical` to a string. Seven literals is seven chances for a typo the
 * compiler cannot see and, more to the point, seven places to find on the day a
 * second vertical grows accounts or this one is renamed. The server collapsed
 * its own copies into `SECURITY_VERTICAL` (`server/src/common/security-account.ts`)
 * for the same reason; this is that file's client half.
 *
 * It is written as **what the vertical has**, not as which vertical it is,
 * because that is what every caller is actually asking: the account chip on the
 * People and Organizations lists, the picker on the two create doors, the
 * selector on the Plan tab, the filter on the knowledge base, the nav item and
 * the `/accounts` pair, and the link on Settings. None of them cares that the
 * word is "security"; each cares that there are accounts to name.
 *
 * The query keys are deliberately **not** routed through here. `['security',
 * orgId, …]` is a cache namespace rather than a statement about an org — it
 * names the family of reads, the way `['knowledge', orgId, …]` does, and it
 * would keep its spelling through a rename of the vertical.
 */
const SECURITY_VERTICAL = 'security';

/**
 * Whether this org's records belong to protection accounts.
 *
 * Takes the shape rather than `MeOrgRef`, so the Plan tab and the two tables —
 * which hold the vertical and not the org — ask the same question through the
 * same rule.
 */
export function orgHasProtectionAccounts(org: { vertical: string }): boolean {
  return org.vertical === SECURITY_VERTICAL;
}
